import { Button } from '@customerio/pluma-components/react';
import * as styles from './index.css';

export function SkipToContent() {
  return (
    <Button as="a" href="#embedded-app-container" size="sm" className={styles.skipToContent} zIndex="tooltip">
      Skip to content
    </Button>
  );
}
